import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MAT_DATE_FORMATS, DateAdapter } from "@angular/material";
import { AppService, APP_DATE_FORMATS, AppDateAdapter } from "../../services/app.service";
import { OrderService } from "../../services/order.service";
import { OrderRemark } from "../../models/order.model";
import { MasterService } from "../../services/master.service";

@Component({
  selector: "app-order-remark",
  templateUrl: "./order-remark.component.html",
  styleUrls: ["./order-remark.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS
    }
  ]
})
export class OrderRemarkComponent implements OnInit {
  public translations;
  private userInfo;
  private CONSTANTS = { ADMIN: 10026, DISTRIBUTER: 10027, SHIPPER: 10030 };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orderService: OrderService,
    public appService: AppService,
    public dialog: MatDialog,
    public orderRemark: OrderRemark,
    public masterService : MasterService,
    public dialogRef: MatDialogRef<OrderRemarkComponent>
  ) {
    this.userInfo = JSON.parse(sessionStorage.pageList)[0];
    this.setPageTranslations();
  }

  ngOnInit() {
    this.getRemark();
  }

  setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
  }

  getRemark(){
    this.appService.showLoading();
    this.orderService.selectOrderRemark(
        this.data.OrderId
      )
      .subscribe(
        res => this.getOrderRemarkSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  getOrderRemarkSuccess(res): void {
    if (res.Status == 1) {
      if(JSON.parse(res.Data).Table.length > 0){
        this.orderRemark = new OrderRemark();
        this.orderRemark = JSON.parse(res.Data).Table[0];
        this.orderRemark.OrderId = this.data.OrderId;
        this.orderRemark.D_ReadDate = this.orderRemark.D_ReadDate == "01-01-1970" ?  "" : this.orderRemark.D_ReadDate;
        this.orderRemark.S_ReadDate = this.orderRemark.S_ReadDate == "01-01-1970" ?  "" : this.orderRemark.S_ReadDate;
      }
      else{
        this.orderRemark = new OrderRemark();
        this.orderRemark.OrderId = this.data.OrderId;
      }
      this.appService.hideLoading();
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  format(date: Date, displayFormat: Object): string {
      if (displayFormat == "input") {
          let day = date.getDate();
          let month = date.getMonth() + 1;
          let year = date.getFullYear();
          return this._to2digit(day) + '-' + this._to2digit(month) + '-' + year 
          + ' ' + this._to2digit(date.getHours()) + ':' + this._to2digit(date.getMinutes()) + ':' + this._to2digit(date.getSeconds());
      } else {
          return date.toDateString();
      }
  }

  private _to2digit(n: number) {
        return ('00' + n).slice(-2);
  } 

  getCurrentDateTime(){
    var dt = new Date();
    return dt.getDay +"-"+ dt.getMonth
  }

  saveRemark(){
    
    this.appService.showLoading();
    debugger;

    let D_IsRead = this.orderRemark.D_IsRead;
    let S_IsRead = this.orderRemark.S_IsRead;
    this.orderRemark.S_IsRead = D_IsRead == 2 && S_IsRead != 2 ? 2 : this.orderRemark.D_Remark != undefined && this.orderRemark.D_Remark.trim() != "" ?  1 : this.orderRemark.S_IsRead;
    this.orderRemark.D_IsRead = S_IsRead == 2 && D_IsRead != 2 ? 2 : this.orderRemark.S_Remark != undefined && this.orderRemark.S_Remark.trim() != "" ?  1 : this.orderRemark.D_IsRead;
    //console.log(this.orderRemark.D_ReadDate);
    //console.log(this.orderRemark.S_ReadDate);
    //console.log(this.strToDate(this.orderRemark.D_ReadDate));
    //console.log(this.strToDate(this.orderRemark.S_ReadDate));
    this.orderRemark.D_ReadDate = this.orderRemark.D_ReadDate != undefined && this.orderRemark.D_ReadDate.toString() != "" ? this.appService.JSONDate(this.strToDate(this.orderRemark.D_ReadDate)) : undefined;
    this.orderRemark.S_ReadDate = this.orderRemark.S_ReadDate != undefined && this.orderRemark.S_ReadDate.toString() != "" ? this.appService.JSONDate(this.strToDate(this.orderRemark.S_ReadDate)) : undefined;
    this.orderRemark.UserType = this.data.RemarkBy == 'distributor' ? 23 : 22;

    this.orderService.saveOrderRemark(
        this.orderRemark
      ).subscribe(
        res => this.saveRemarkSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  saveRemarkSuccess(res): void {
    if (res.Status == 1) {
      this.appService.hideLoading();
      //this.appService.showDialogue("Success", this.translations[res.Message]);
      this.dialogRef.close();
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue("Error", this.translations[error]);
  }

  shipperMarkedAsReadChanged(e){
    
    if(e.checked){
      this.orderRemark.S_Id = sessionStorage.authToken;
      this.orderRemark.S_Name = this.userInfo.UserName;
      this.orderRemark.S_ReadDate = this.format(new Date(), 'input');
      this.orderRemark.S_IsRead = 2;
    }else{
      this.orderRemark.S_Id = sessionStorage.authToken;
      this.orderRemark.S_Name = this.userInfo.UserName;
      this.orderRemark.S_ReadDate = undefined;
      this.orderRemark.S_IsRead = 1;
    }
  }

  distributorMarkedAsReadChanged(e){
    
    if(e.checked){
      this.orderRemark.D_Id = sessionStorage.authToken;
      this.orderRemark.D_Name = this.userInfo.UserName;
      this.orderRemark.D_ReadDate = this.format(new Date(), 'input');
      this.orderRemark.D_IsRead = 2;
    }else{
      this.orderRemark.D_Id = sessionStorage.authToken;
      this.orderRemark.D_Name = this.userInfo.UserName;
      this.orderRemark.D_ReadDate = undefined;
      this.orderRemark.D_IsRead = 1;
    }
  }

  strToDate(dtStr) {
    if (!dtStr) return null
    let dateParts = dtStr.split("-");
    let timeParts = dateParts[2].split(" ")[1].split(":");
    dateParts[2] = dateParts[2].split(" ")[0];
    // month is 0-based, that's why we need dataParts[1] - 1
    return  new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1], timeParts[2]);
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order-remark/order-remark.component.ts